<template>
  <div>
    <FormGroup>
      <h5 class="name">{{startTitle}}</h5>
      <DateTimePicker
        :value="startTime"
        @input="onUpdateStartTime"
        :maximumDate="endTime"
        :placeholder="'กรุณาเลือกวันที่'" />
    </FormGroup>
    <FormGroup>
      <h5 class="name">{{endTitle}}</h5>
      <DateTimePicker
        :value="endTime"
        @input="onUpdateEndTime"
        :minimumDate="startTime"
        :placeholder="'กรุณาเลือกวันที่'" />
    </FormGroup>
  </div>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker.vue';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    startTime: {
      type: [Date, String],
      default: null,
    },
    endTime: {
      type: [Date, String],
      default: null,
    },
    startTitle: {
      type: String,
      default: 'เวลาเริ่มถ่ายทอดสด',
    },
    endTitle: {
      type: String,
      default: 'เวลาจบการถ่ายทอดสด',
    },
  },
  components: {
    DateTimePicker,
    FormGroup,
  },
  methods: {
    onUpdateStartTime(startTime) {
      this.$emit('update:startTime', startTime);
    },
    onUpdateEndTime(endTime) {
      this.$emit('update:endTime', endTime);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
